/*
 * View for the content title and type
 */

define([
  "marionette",
  "modules/contentsSplit/content/contentTitle/template/contentTitleTemplate.html",
], function (Marionette, ContentTitleTemplate) {
  var ContentTitleView = {};

  ContentTitleView.contentTitleView = Marionette.ItemView.extend({
    template: ContentTitleTemplate,
    modelEvents: {
      change: "render",
    },
    showTitleError: function (errorMessage) {
      this.$el
        .find("#contentTitleText")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    textboxes: {
      "#contentTitleText": {
        enableSelector: "#contentTitleText",
        modelAttribute: "name",
        placeholder: "content.titlePlaceholder",
        textArea: false,
      },
    },
  });

  return ContentTitleView;
});
